import {
	type ClientResponse,
	handleSuccess,
	moduleName,
	type RequestPayload,
	type ServerResponse,
} from "@onhandtech/onhand-fe-shared/lib/api/v5/campaign/post-campaign";
import { createReduxServiceModule } from "@onhandtech/onhand-fe-shared/lib/redux";
import {
	createRequestError,
	formatEndpoint,
	type RequestArgs,
} from "@onhandtech/onhand-fe-shared/lib/request";
import type { AxiosError } from "axios";

import { getConfig } from "../../../../../config/configuration";

const args: RequestArgs<ServerResponse, ClientResponse, never, RequestPayload> =
	{
		handleFailure: (error: AxiosError) =>
			createRequestError(
				error,
				error.status?.toString() ?? moduleName,
				moduleName,
			),
		handleSuccess,
		method: "POST",
		url: formatEndpoint(getConfig().endpoints.api.v5.campaign),
	};

const getCampaignModule = () =>
	createReduxServiceModule<
		ServerResponse,
		ClientResponse,
		never,
		RequestPayload
	>({
		args,
		moduleName,
	});

export default getCampaignModule;
